
import React from "react";

interface CameraErrorDisplayProps {
  errorMessage: string;
}

export function CameraErrorDisplay({ errorMessage }: CameraErrorDisplayProps) {
  return (
    <div className="absolute inset-0 flex items-center justify-center bg-red-50 p-4">
      <p className="text-red-500 text-center">{errorMessage}</p>
    </div>
  );
}

export default CameraErrorDisplay;
